import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { Button, Col, Container, Spinner } from 'react-bootstrap'
import "../../styles/multipliers-styles.scss"
import FeatherIcon from 'feather-icons-react';
import { setGlobalLoading } from 'redux/actions/actionCommon'
import FormCategoryMultiplier from "./Includes/FormCategoryMultiplier"
import { toast } from 'react-toastify';
import {
    getCategoriesTree,
} from 'utlis/Apis/Categories_API'
import {
    UNKNOWN_ERROR_OCCURED,
    ERROR_WHILE__NAME,
    ERROR_WHILE_CREATING_CATEGORY,
} from 'utlis/AppMessages/AppMessages'
import { Link } from 'react-router-dom';
import { updateCategoryMultiplier } from 'utlis/Apis/Multipliers_API';
import { ERROR_WHILE_UPDATING_BRAND } from 'utlis/AppMessages/AppMessages';
import { CATEGORY_MULTIPLIERS_UPDATED_SUCCESSFULLY } from 'utlis/AppMessages/AppMessages';


function CategoryMultiplier(props) {
    const [categories, setCategories] = useState([])
    const [categoriesLoading, setCategoriesLoading] = useState(false)
    const categoriesLoadingIndicator = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]

    const [ExpandedCategories, setExpandedCategories] = useState([])
    const [multipliers, setMultipliers] = useState([])
    const [multiplierLoading, setMultiplierLoading] = useState(false)

    useEffect(() => {
        setCategoriesLoading(true)
        getCategoriesTree(props.currentUser.userToken).then(res => {
            setCategoriesLoading(false)

            const catsData = res.data
            if (catsData.success) {
                window.scrollTo(0, 0)
                setCategories(catsData.data)
                const array = []
                catsData.data.forEach(e => {
                    array.push({
                        category_id: e.category_id, // brand_id
                        c_multiplier: e.multiplier || 0,
                        c_multiplier_type: e.multiplier_type || "percent"
                    })
                    if (Array.isArray(e.sub_categories)) {
                        e.sub_categories.forEach(i => {
                            array.push({
                                category_id: i.category_id, // brand_id
                                c_multiplier: i.multiplier || 0,
                                c_multiplier_type: i.multiplier_type || "percent"
                            })
                        })
                    }
                })
                setMultipliers(array)

            }

            if (catsData.error) {
                console.log(ERROR_WHILE_CREATING_CATEGORY, res)

                toast.dismiss();
                toast.error(ERROR_WHILE_CREATING_CATEGORY, {
                    autoClose: 3000,
                })
            }
        }).catch(err => {
            console.log(`${ERROR_WHILE__NAME} getCategoriesTree `, err.message)
            toast.dismiss();
            toast.error(UNKNOWN_ERROR_OCCURED, {
                autoClose: 2500,
                onClose: () => {
                    setCategoriesLoading(false)
                }
            })
        })
    }, [props.currentUser.userToken])

    const updateMultiplier = (id, multiplier, type) => {
        const newArray = multipliers.filter(e => parseInt(e.category_id) !== parseInt(id))
        newArray.push({
            category_id: id,
            c_multiplier: multiplier,
            c_multiplier_type: type
        })
        setMultipliers(newArray)
    }
    const updateMultipliers = () => {
        setMultiplierLoading(true)
        updateCategoryMultiplier(props.currentUser.userToken, multipliers).then(res => {
            // setLoading(false)
            const resData = res.data
            window.scrollTo(0, 0)
            if (resData && resData.success) {
                toast.success(CATEGORY_MULTIPLIERS_UPDATED_SUCCESSFULLY, {
                    autoClose: 3000
                })
                setMultiplierLoading(false)
            }

            // if request is not succesfull
            if (resData && resData.error) {
                // dismissing all the previous toasts first
                toast.dismiss();

                // showing the error message
                toast.error(ERROR_WHILE_UPDATING_BRAND, {
                    autoClose: 3000,
                    onClose: () => {
                        // disabling loading
                        // setLoading(false)
                    }
                })
            }
        })

    }


    const handleExpandCategory = (ev, id) => {
        ev.preventDefault()
        if (id) {
            let ifIdExists = ExpandedCategories.find(item => item === id)

            if (ifIdExists) {
                let updatedList = ExpandedCategories.filter(item => item !== id)

                setExpandedCategories(updatedList)
            } else {
                setExpandedCategories([...ExpandedCategories, id])
            }
        }
    }
    return (
        <section id="app-multipliers" className="st-def-mar-TB page-eorc-wrapper">
            <Container fluid className="st-container">
                <div className="app-categories-multipliers">
                    <Link
                        className="st-btn st-btn-link text-primary border-light bg-transparent no-min-width st-btn-sm p-0 min-height-auto"
                        to="/catalog/multipliers"
                    >
                        <FeatherIcon
                            icon="arrow-left"
                            size="14"
                            className="icon me-2" />
                        <span>Back</span>
                    </Link>
                    <div className="app-header-category mb-3">
                        <p className="app-heading text-capitalize">Category Multiplier</p>
                        <p className="app-desc">Setup of Category Multipliers</p>
                    </div>
                    <Col xs={12} md={12} lg={11} className="px-0">
                        <div className="app-card">
                            <div className="app-card-content border st-default-rounded-block pad-20">
                                <div className="app-card">
                                    <div className="app-header-wrapper d-flex justify-content-between mb-2 pb-1  pad-25-R pad-25-L">
                                        <p className="app-multiplier-desc mb-1">Product/Service</p>
                                        <p className="app-multiplier-desc">Category Multiplier</p>
                                    </div>
                                    <div className="app-card-content">
                                        <Col xs={12} md={9} lg={12} className="px-0">
                                            <FormCategoryMultiplier
                                                categoriesLoading={categoriesLoading}
                                                categoriesLoadingIndicator={categoriesLoadingIndicator}
                                                categories={categories}
                                                ExpandedCategories={ExpandedCategories}
                                                multipliers={multipliers}
                                                updateMultiplier={updateMultiplier}
                                                handleExpandCategory={(ev, id) => handleExpandCategory(ev, id)}
                                            />
                                            <div className="d-flex justify-content-end mt-4">
                                                <div className="cats-all-btns-inner d-flex flex-wrap align-items-center justify-content-between">
                                                    <div className="cats-all-btns-right d-flex flex-wrap  justify-content-start align-items-center">
                                                        <Button
                                                            className="st-btn st-btn-gray no-min-width st-btn-sm d-flex align-items-center justify-content-center btn btn-primary me-2">
                                                            <FeatherIcon
                                                                icon="rotate-cw"
                                                                size="14"
                                                                className="icon me-2" />
                                                            <span>Reset</span>
                                                        </Button>
                                                        <Button
                                                            className="st-btn st-btn-primary no-min-width st-btn-sm d-flex align-items-center justify-content-center btn btn-primary"
                                                            onClick={updateMultipliers}
                                                        >

                                                            {
                                                                multiplierLoading ? (
                                                                    <Spinner animation="border" size="sm" />
                                                                ) : (
                                                                    <>
                                                                        <FeatherIcon
                                                                            icon="download"
                                                                            size="14"
                                                                            className="icon me-2" />

                                                                        <span>Save</span>
                                                                    </>
                                                                )}
                                                        </Button>
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Col>
                </div>
            </Container >
        </section >
    )
}

const getDataFromStore = state => {
    return {
        currentUser: state.auth.currentUser
    };
}

const dispatchActionsToProps = dispatch => {
    return {
        setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
    }
}

export default connect(getDataFromStore, dispatchActionsToProps)(CategoryMultiplier)